import React from 'react';

interface IProps {
  content: string;
}

const FeedbackText = ({ content }: IProps) => {
  return <div className="FeedbackText">{content}</div>;
};

export default FeedbackText;
